<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <p class="primary--text mb-2 font-weight-bold">
          Filtrar
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="8" class="pr-sm-5 pr-0">
        <BaseFormAutocomplete
          id-element="filterEndorsement"
          placeholder="Tomador Matriz/Filial ou CNPJ"
          v-model="endorsementFilter.filter"
          :items="currentTakerQuotation"
          hide-no-data
          item-text="nome_fantasia"
          item-value="id"
          template-taker
          validate-on-blur
          @keyup="searchInput"
          :return-object="true"
          ref="filterInput"
          blur
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <p class="primary--text font-weight-bold body-2 mb-0">
          Status
        </p>
        <v-checkbox
          v-model="endorsementFilter.vigente"
          label="Vigente"
          class="d-inline-block pr-5 ma-0 policy-table__checkbox pt-0"
          dense
        />
        <v-checkbox
          v-model="endorsementFilter.nao_vigente"
          label="Não Vigente"
          dense
          class="d-inline-block ma-0 policy-table__checkbox pt-0"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="pr-md-5 pr-0">
        <BaseSelect
          placeholder="Tipos de Filtros"
          :items="listTypesFilterEndorsement"
          v-model="endorsementFilter.tipo"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col
        cols="12"
        sm="3"
        md="2"
        class="pr-md-5 pr-0"
        v-if="indexIntervalDateFilter > -1"
      >
        <BaseFilter
          v-model="endorsementFilter.inicio"
          :textPlaceholder="'DD/MM/AAAA'"
          outlined
          dense
          v-facade="maskDate"
          :rules="[dateTermValid, requiredInput]"
          validate-on-blur
          required
        />
      </v-col>
      <v-col
        cols="12"
        sm="3"
        md="2"
        class="pr-md-5 pr-0"
        v-if="indexIntervalDateFilter > -1"
      >
        <BaseFilter
          v-model="endorsementFilter.fim"
          :textPlaceholder="'DD/MM/AAAA'"
          outlined
          dense
          v-facade="maskDate"
          :rules="[dateTermValid, requiredInput]"
          validate-on-blur
          required
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="pr-md-5 pr-0"
        v-if="indexIntervalDateFilter == -1"
      >
        <BaseSelect
          placeholder="Selecione"
          :items="currentSelectFilterQuotation"
          v-model="endorsementFilter.valor"
          v-if="indexSelectFilter > -1"
          :multiple="true"
          item-text="nome"
          item-value="id"
          required
          :rules="[requiredInput]"
        />
        <BaseFilter
          v-model="endorsementFilter.valor"
          :textPlaceholder="'Informe'"
          outlined
          dense
          v-if="indexNormalFilter > -1"
          required
          :rules="[requiredInput]"
        />
        <BaseFormAutocomplete
          id-element="autocompleteQuotation"
          placeholder="Autocomplete"
          v-model="endorsementFilter.valor"
          :items="currentAutoCompleteFilterQuotation"
          hide-no-data
          item-text="nome"
          item-value="id"
          validate-on-blur
          @keyup="searchInput"
          v-if="indexAutocompleteFilter > -1 && indexAutocompleteFilter != 3"
          :return-object="true"
          required
          :rules="[requiredInput]"
        />
        <BaseFormAutocomplete
          id-element="autocompleteQuotation"
          placeholder="Autocomplete"
          v-model="endorsementFilter.valor"
          :items="currentAutoCompleteFilterQuotation"
          hide-no-data
          item-text="numero"
          item-value="id"
          validate-on-blur
          @keyup="searchInput"
          v-if="indexAutocompleteFilter == 3"
          :return-object="true"
          required
          :rules="[requiredInput]"
        />
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="6" md="2" class="pr-0 pb-5 pb-md-0 pr-sm-3">
        <BaseButton
          v-html="'PESQUISAR'"
          class="secondary white--text"
          width="100%"
          @click="searchByFilter"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pb-5 pb-md-0">
        <BaseButton
          v-html="'LIMPAR'"
          color="secondary"
          width="100%"
          outlined
          @click="resetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <BaseDataTable
          :headers="header"
          :items="endorsements.items"
          no-data-text="Nenhum Endosso foi encontrado"
          :options.sync="options"
          :server-items-length="endorsements.total_count"
          @click:row="redirectToEndorsement"
        >
          <template v-slot:[`item.tipo`]="{ item }">
            {{ item.tipo.nome }}
          </template>
          <template v-slot:[`item.inicio_vigencia`]="{ item }">
            {{ formatDateToDDMMYYYY(item.inicio_vigencia) }} a
            {{ formatDateToDDMMYYYY(item.fim_vigencia) }}
          </template>
          <template
            v-slot:[`item.apolice.valor_importancia_segurada`]="{ item }"
          >
            {{ asMoneyString(item.apolice.valor_importancia_segurada) }}
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            {{ item.status.nome }}
          </template>
          <template v-slot:[`item.arquivo`]="{ item }">
            <BaseButton
              color="secondary"
              class="px-0 mr-2 form__button-data-table"
              @click.stop="onPreviewFile(item)"
            >
              <v-icon color="white">
                fa-file
              </v-icon>
            </BaseButton>
            <BaseButton
              v-if="item.boletos.length > 0"
              color="secondary"
              class="px-0 form__button-data-table"
              @click.stop="showModalBills(item)"
            >
              <v-icon color="white">
                fa-barcode
              </v-icon>
            </BaseButton>
          </template>
        </BaseDataTable>
      </v-col>
    </v-row>
    <ModalListFiles
      v-model="modalDocuments"
      :items="currentListBills"
      @close="closeModalDocuments"
    />
  </v-form>
</template>
<script>
const tableHeaders = [
  { text: "N° Endosso", value: "numero", sortable: true },
  { text: "Tipo", value: "tipo", sortable: true },
  { text: "Vigência", value: "inicio_vigencia", sortable: true },
  { text: "N° Apólice", value: "apolice.numero", sortable: true },
  {
    text: "Tomador Matriz/Filial",
    value: "apolice.tomador.nome_fantasia",
    sortable: true
  },
  {
    text: "Valor IS (Atual)",
    value: "apolice.valor_importancia_segurada",
    sortable: true
  },
  { text: "Status", value: "situacao", sortable: true },
  { text: "Endosso/Boleto", value: "arquivo", sortable: false }
];
const MOCK_OPTIONS = {
  groupBy: [],
  groupDesc: [],
  itemsPerPage: 5,
  multiSort: false,
  mustSort: false,
  page: 1,
  sortBy: [],
  sortDesc: []
};
const MOCK_FILTER = {
  nao_vigente: false,
  vigente: false,
  valor: null,
  tipo: {
    nome: null,
    id: null
  },
  filter: null,
  inicio: null,
  fim: null
};
import { asMoneyString, formatDateToDDMMYYYY } from "@/utils/formats.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { maskDate } from "@/utils/masks.js";
import { dateTermValid, requiredInput } from "@/utils/rules.js";
import _ from "lodash";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import ModalListFiles from "@/modules/policy/components/ModalListFiles";
import FilterEndorsementMixin from "../mixins/FilterEndorsementMixin";
export default {
  data() {
    return {
      endorsementFilter: null,
      currentFilter: null,
      header: tableHeaders,
      asMoneyString,
      options: MOCK_OPTIONS,
      maskDate,
      formatDateToDDMMYYYY,
      dateTermValid,
      requiredInput,
      modalDocuments: false,
      currentListBills: []
    };
  },
  watch: {
    options: {
      handler(value) {
        this.fetchEndorsement(this.getPayload(value, this.currentFilter));
      },
      deep: true
    },
    "endorsementFilter.tipo"() {
      // Toda vez que trocar o filtro, tem que resertar o valor antigo
      this.endorsementFilter.valor = null;
      this.endorsementFilter.inicio = null;
      this.endorsementFilter.fim = null;
      this.resetCurrentFilters();
      if (this.indexSelectFilter > -1)
        this.fetchSelectFilter(this.indexSelectFilter);
    }
  },
  mixins: [LoadingRequest, DocumentsMixin, FilterEndorsementMixin],
  created() {
    this.initialize();
  },
  components: {
    ModalListFiles
  },
  computed: {
    ...mapState("quotation", [
      "currentAutoCompleteFilterQuotation",
      "currentTakerQuotation",
      "currentSelectFilterQuotation"
    ]),
    ...mapState("endorsement", ["endorsements"]),
    indexAutocompleteFilter() {
      return this.MOCK_AUTOCOMPLETE_FILTER.indexOf(
        this.endorsementFilter.tipo.nome
      );
    },
    indexSelectFilter() {
      return this.MOCK_SELECT_FILTER.indexOf(this.endorsementFilter.tipo.nome);
    },
    indexNormalFilter() {
      return this.MOCK_NORMAL_FILTER.indexOf(this.endorsementFilter.tipo.nome);
    },
    indexIntervalDateFilter() {
      return this.MOCK_INTERVAL_DATE_FILTER.indexOf(
        this.endorsementFilter.tipo.nome
      );
    },
    requiredValidTaker() {
      return (
        this.validateFilterTaker() || "É preciso selecionar um tomador válido"
      );
    }
  },
  methods: {
    ...mapActions("endorsement", ["requestListEndorsement"]),
    initialize() {
      this.currentFilter = _.cloneDeep(MOCK_FILTER);
      this.endorsementFilter = _.cloneDeep(MOCK_FILTER);
    },
    fetchEndorsement(payload) {
      this.withLoading(this.requestListEndorsement(payload));
    },
    searchByFilter() {
      if (!this.validate()) return;
      this.currentFilter = _.cloneDeep(this.endorsementFilter);
      this.fetchEndorsement(this.getPayload(this.options, this.currentFilter));
    },
    resetFilter() {
      this.options = _.cloneDeep(MOCK_OPTIONS);
      this.endorsementFilter = _.cloneDeep(MOCK_FILTER);
      this.currentFilter = _.cloneDeep(MOCK_FILTER);
      this.fetchEndorsement(this.getPayload(this.options, this.currentFilter));
    },
    showModalBills(item) {
      if (item.boletos.length == 1) {
        this.onPreviewFile(item.boletos[0]);
      } else {
        this.currentListBills = item.boletos;
        this.modalDocuments = true;
      }
    },
    closeModalDocuments() {
      this.modalDocuments = false;
    },
    validate() {
      const validateForm = this.endorsementFilter.tipo.id
        ? this.$refs.form.validate()
        : true;
      return validateForm;
    },
    validateFilterTaker() {
      return (
        !this.endorsementFilter.filter ||
        Boolean(this.endorsementFilter.filter?.id)
      );
    },
    redirectToEndorsement(item) {
      this.$router.push({
        name: "edit endorsement policy",
        params: { endosso: item.id, id: item.apolice.id }
      });
    }
  }
};
</script>
